<template>
    <aside>
        <header class="mb-3 d-flex">
            <search-input v-model="search" class="flex-grow-1"/>

            <b-button
                :to="{ name: 'staff_members.create' }"
                :title="$t('Create new staff member')"
                variant="primary"
                class="ml-3"
            >
                <fa icon="plus" :title="$t('Create new staff member')" />
            </b-button>
        </header>

        <nav>
            <b-list-group tag="ul">
                <b-list-group-item
                    v-for="staffMember in items"
                    :key="staffMember.id"
                    :to="{ name: 'staff_members.show', params: { staffMemberId: staffMember.id } }"
                    class="flex-column align-items-start mb-1"
                    tag="li"
                >
                    <div class="d-flex w-100 justify-content-between">
                        <h2 class="h5 mb-1">
                            {{ staffMember.name }}
                        </h2>
                    </div>
                </b-list-group-item>
            </b-list-group>
        </nav>

        <b-pagination
            v-if="showPagination"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            limit="3"
        />

        <div v-show="pending" class="text-center mt-1">
            <b-spinner/>
        </div>
    </aside>
</template>
<script>
import fetchPaginatedData from '@/mixins/fetchPaginatedData';
import SearchInput from "@/components/SeachInput";

export default {
    name: 'StaffMembers',
    components: {SearchInput},
    mixins: [fetchPaginatedData],
    computed: {
        apiUrl() {
            return '/api/staff_members'
        }
    },
    created() {
        let _this = this;

        this.$root.$on('created::staff_member', function(data) {
            _this.items.unshift(data);
            _this.totalRows += 1;
            if (_this.items.length > _this.perPage) {
                _this.items.pop();
            }
        });

        this.$root.$on('updated::staff_member', function(data) {
            let index = _this.items.findIndex(({id}) => id === data.id);
            _this.items.splice(index, 1, data);
        });

        this.$root.$on('deleted::staff_member', function(userId) {
            let index = _this.items.findIndex(({id}) => id === userId);
            _this.items.splice(index, 1);
        });
    },
}
</script>
